import React from 'react'

interface AppWrapperSubtitleProps {
  children: React.ReactNode
}

const AppWrapperSubtitle: React.FC<AppWrapperSubtitleProps> = ({ children }) => {
  return (
    <div
      className="text-[#9B99B1] uppercase text-[14px] leading-tight"
      style={{ letterSpacing: '0.7px', fontWeight: '600' }}
    >
      {children}
    </div>
  )
}

export default AppWrapperSubtitle
